// Offline icon bundle. Each glyph is statically imported via unplugin-icons, so
// only these ~15 icons are bundled (tree-shaken from the full @iconify/json data)
// and there is NO runtime request to api.iconify.design. Keyed by the
// "collection:name" string the <Icon> component API already uses everywhere, so
// adding an icon here is the only step needed to use a new one.
import MsMailRounded from '~icons/material-symbols/mail-rounded';
import MsShuffle from '~icons/material-symbols/shuffle';
import MsGroups from '~icons/material-symbols/groups';
import MsPrint from '~icons/material-symbols/print';
import MsCalendarViewWeek from '~icons/material-symbols/calendar-view-week';
import MsNestMultiRoom from '~icons/material-symbols/nest-multi-room';
import ViExcel from '~icons/vscode-icons/file-type-excel2';
import SiCanvas from '~icons/simple-icons/canvas';
import FaUserGraduate from '~icons/fa6-solid/user-graduate';
import FaTriangleExclamation from '~icons/fa6-solid/triangle-exclamation';
import FaEye from '~icons/fa6-solid/eye';
import FaChalkboardUser from '~icons/fa6-solid/chalkboard-user';
import FaMagnifyingGlass from '~icons/fa6-solid/magnifying-glass';
import FaHouse from '~icons/fa6-solid/house';
import FaXmark from '~icons/fa6-solid/xmark';

export const iconMap = {
    'material-symbols:mail-rounded': MsMailRounded,
    'material-symbols:shuffle': MsShuffle,
    'material-symbols:groups': MsGroups,
    'material-symbols:print': MsPrint,
    'material-symbols:calendar-view-week': MsCalendarViewWeek,
    'material-symbols:nest-multi-room': MsNestMultiRoom,
    'vscode-icons:file-type-excel2': ViExcel,
    'simple-icons:canvas': SiCanvas,
    'fa6-solid:user-graduate': FaUserGraduate,
    'fa6-solid:triangle-exclamation': FaTriangleExclamation,
    'fa6-solid:eye': FaEye,
    'fa6-solid:chalkboard-user': FaChalkboardUser,
    'fa6-solid:magnifying-glass': FaMagnifyingGlass,
    'fa6-solid:house': FaHouse,
    'fa6-solid:xmark': FaXmark,
};
